import axios, { AxiosResponse } from 'axios'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

export interface UserData {
  id: string
  firstName: string
  lastName: string
  dashboardLocale: PageLocaleEnum
  hasWhiteLabel: boolean
}
export const getUserData = (): Promise<AxiosResponse<UserData>> => {
  return axios.get(`/api/user/user-data`)
}
